import { useState } from 'react';
import './CardContacto.css';

const DATOS = {
  direccion: 'Calle 38 No. 29 - 18, Carretera Troncal',
  telefono: '(+57) 312 743 1631',
  telefonoHref: 'tel:+573127431631',
  email: 'coordinadoracadémico.sucre@cruzrojacolombiana.org',
  emailHref: 'mailto:coordinadoracadémico.sucre@cruzrojacolombiana.org',
  whatsapp: '573127431631',
  mapaSrc:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3937.402765284644!2d-75.38182292600095!3d9.297533884729818!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e5915b1ace1de83%3A0x2f934a49a13031f5!2sCruz%20Roja%20Colombiana%20-%20Seccional%20Sucre!5e0!3m2!1ses!2sco!4v1787427620603!5m2!1ses!2sco',
};

const ASUNTOS = [
  'Información general',
  'Programas técnicos',
  'Diplomados',
  'Admisiones',
  'Otro',
];

const estadoInicial = {
  nombres: '',
  celular: '',
  correo: '',
  asunto: '',
  mensaje: '',
};

const CardContacto = () => {
  const [form, setForm] = useState(estadoInicial);
  const [errores, setErrores] = useState({});
  const [cargando, setCargando] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [errorEnvio, setErrorEnvio] = useState('');

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
    setErrores((prev) => ({ ...prev, [name]: '' }));
    setEnviado(false);
    setErrorEnvio('');
  };

  const validar = () => {
    const next = {};
    if (!form.nombres.trim()) next.nombres = 'Ingresa tu nombre.';
    if (!/^\d{7,15}$/.test(form.celular.replace(/\s/g, ''))) {
      next.celular = 'Ingresa un celular válido (solo números).';
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.correo.trim())) {
      next.correo = 'Ingresa un correo válido.';
    }
    if (!form.asunto) next.asunto = 'Selecciona un asunto.';
    if (form.mensaje.trim().length < 10) {
      next.mensaje = 'El mensaje debe tener al menos 10 caracteres.';
    }
    return next;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const next = validar();
    setErrores(next);
    if (Object.keys(next).length > 0) return;

    setCargando(true);
    setErrorEnvio('');
    setEnviado(false);

    try {
      const response = await fetch('/enviar_correo.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(form),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setEnviado(true);
        setForm(estadoInicial);
      } else {
        setErrorEnvio(data.message || 'No se pudo enviar el mensaje. Inténtalo de nuevo.');
      }
    } catch (err) {
      setErrorEnvio('Error de conexión con el servidor. Inténtalo de nuevo más tarde.');
    } finally {
      setCargando(false);
    }
  };

  return (
    <section className="contacto">
      <div className="contacto__hero">
        <div className="contacto__hero-inner">
          <span className="contacto__hero-bar" />
          <div>
            <h1>Contacto</h1>
            <p>Estamos aquí para ayudarte. Escríbenos, te atenderemos con gusto.</p>
          </div>
        </div>
      </div>

      <div className="contacto__grid">
        <div className="contacto__col">
          <article className="contacto-info">
            <span className="contacto-info__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 21s7-5.4 7-11a7 7 0 1 0-14 0c0 5.6 7 11 7 11z" />
                <circle cx="12" cy="10" r="2.5" />
              </svg>
            </span>
            <div>
              <h2>Dirección</h2>
              <p>{DATOS.direccion}</p>
            </div>
          </article>

          <article className="contacto-info">
            <span className="contacto-info__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.6a2 2 0 0 1-.5 2.1L8 9.9a16 16 0 0 0 6 6l1.5-1.2a2 2 0 0 1 2.1-.5c.8.3 1.7.5 2.6.6A2 2 0 0 1 22 16.9z" />
              </svg>
            </span>
            <div>
              <h2>Teléfono</h2>
              <p>
                <a href={DATOS.telefonoHref}>{DATOS.telefono}</a>
              </p>
            </div>
          </article>

          <article className="contacto-info">
            <span className="contacto-info__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="5" width="18" height="14" rx="2" />
                <path d="M3 7l9 6 9-6" />
              </svg>
            </span>
            <div>
              <h2>Correo Electrónico</h2>
              <p>
                <a href={DATOS.emailHref}>{DATOS.email}</a>
              </p>
            </div>
          </article>

          <div className="contacto-mapa">
            <iframe
              src={DATOS.mapaSrc}
              title="Ubicación Cruz Roja Colombiana - Seccional Sucre"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen=""
            />
          </div>
        </div>

        <form className="contacto-form" onSubmit={handleSubmit} noValidate>
          <h2>Escríbenos</h2>
          <p>Completa el formulario y nos pondremos en contacto lo antes posible.</p>

          <div className="contacto-form__row">
            <label>
              <span className="sr-only">Nombres</span>
              <input
                name="nombres"
                type="text"
                placeholder="Nombres"
                value={form.nombres}
                onChange={onChange}
                autoComplete="name"
              />
              {errores.nombres && <small>{errores.nombres}</small>}
            </label>
            <label>
              <span className="sr-only">Celular</span>
              <input
                name="celular"
                type="tel"
                placeholder="Celular"
                value={form.celular}
                onChange={onChange}
                autoComplete="tel"
              />
              {errores.celular && <small>{errores.celular}</small>}
            </label>
          </div>

          <label>
            <span className="sr-only">Correo Electrónico</span>
            <input
              name="correo"
              type="email"
              placeholder="Correo Electrónico"
              value={form.correo}
              onChange={onChange}
              autoComplete="email"
            />
            {errores.correo && <small>{errores.correo}</small>}
          </label>

          <label>
            <span className="sr-only">Asunto</span>
            <select name="asunto" value={form.asunto} onChange={onChange}>
              <option value="">Asunto</option>
              {ASUNTOS.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
            {errores.asunto && <small>{errores.asunto}</small>}
          </label>

          <label>
            <span className="sr-only">Mensaje</span>
            <textarea
              name="mensaje"
              rows="5"
              placeholder="Mensaje"
              value={form.mensaje}
              onChange={onChange}
            />
            {errores.mensaje && <small>{errores.mensaje}</small>}
          </label>

          <button type="submit" disabled={cargando}>
            {cargando ? 'Enviando mensaje...' : 'Enviar'}
          </button>

          {enviado && (
            <p className="contacto-form__ok">
              ¡Tu mensaje ha sido enviado con éxito! Nos comunicaremos contigo pronto.
            </p>
          )}

          {errorEnvio && (
            <p className="contacto-form__error">
              {errorEnvio}
            </p>
          )}
        </form>
      </div>
    </section>
  );
};

export default CardContacto;